export const sxSettingTextField = {
    textTransform: 'uppercase',
    letterSpacing: 1,
    fontSize: 14,
    fontWeight: 500,
    color: '#374151',
    mb: 1,
    ml: 0.5,
    fontFamily: 'PF DIN Text Pro'
}
export * from "./sxSettingTextField";